let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ggjno")).then(() => parcelRequire('hs5Yt'));